// Sniff London — Email Gate
var SNF_WORKER_URL = 'https://snifflondon-reading.twilight-dawn-fdb7.workers.dev';

(function(){
  'use strict';

  var MR = {
    'The Rake': 'You move through rooms like a fuse already lit — nobody quite knows when it will catch, only that it will. Your blind spot is mistaking velocity for connection: the faster you move toward someone, the less they get to actually arrive with you. What makes you dangerous isn’t the chase, it’s how completely you mean it while it lasts.',
    'The Ideal Lover': 'You walk into a room and quietly catalogue what’s missing in everyone you meet — then become it, one conversation at a time. Your blind spot is confusing being needed with being chosen; you can engineer devotion so precisely you forget to ask whether it’s you they want. What makes you irresistible is that the mirror you hold up is never flattering, it’s accurate.',
    'The Star': 'You don’t enter rooms, you arrive in them — there’s a difference, and everyone feels it even if they can’t name it. Your blind spot is treating closeness like erosion, so you keep just enough distance that the want never fully resolves. What makes you magnetic is the gap between how unreachable you seem and how badly, privately, you want someone to close it.',
    'The Natural': 'You make ease look like a decision, when really it’s the absence of one — you simply never learned to perform, and that omission is the most disarming thing in any room. Your blind spot is assuming everyone operates with the same lack of agenda you do. What makes you magnetic is that you offer intimacy at the speed of trust, not the speed of seduction.',
    'The Charmer': 'You read a room the way other people read weather — instantly, instinctively, adjusting before anyone notices you’ve moved. Your blind spot is that all that attention can become choreography even you stop being able to see past. What makes you irresistible is how completely seen people feel around you.',
    'The Charismatic': 'You don’t ask for the room’s attention, the room reorganises itself around you — and you’ve gotten so used to that gravity you sometimes forget what it costs the people standing closest. Your blind spot is presence without pause. What makes you magnetic is that the energy is real, not performed.',
    'The Siren': 'You don’t pursue, you create weather — an atmosphere thick enough that people walk into it and call it choice. Your blind spot is letting mystery do all the labour intimacy is supposed to do. What makes you dangerous is that none of it is calculated — the pull is real, which is exactly why people can’t talk themselves out of it.',
    'The Dandy': 'You treat identity like a wardrobe — nothing fixed, everything chosen, and the choosing is the seduction. Your blind spot is that endless reinvention can become a way of never being caught, and people can’t hold what refuses to hold still. What makes you unforgettable is that you give a room something it can’t categorise.',
    'The Coquette': 'You understand something most people never learn: that presence is worth more when it’s rationed. You give, then vanish, and the vanishing is where the wanting is built. Your blind spot is that a game played too well stops feeling like a game to the other person — and no one chases forever.'
  };

  var GATE_CSS = [
    '.snf-gate-wrap{border:1px solid rgba(207,167,106,.35);background:rgba(207,167,106,.06);padding:28px 24px;margin:24px 0;text-align:center;font-family:\'Inter\',sans-serif;}',
    '.snf-gate-wrap .snf-ge{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#cfa76a;margin-bottom:6px;}',
    '.snf-gate-wrap .snf-gt{font-size:20px;font-weight:700;text-transform:uppercase;margin:0 0 8px;color:#f4efe6;font-family:\'Barlow Condensed\',sans-serif;}',
    '.snf-gate-wrap .snf-gs{font-size:12px;color:#a89f92;max-width:380px;margin:0 auto 16px;line-height:1.6;}',
    '.snf-gate-wrap input[type=email],.snf-gate-wrap input[type=tel]{width:100%;max-width:340px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.18);color:#fff;padding:12px 14px;font-size:14px;margin:0 auto 10px;display:block;font-family:\'Inter\',sans-serif;box-sizing:border-box;}',
    '.snf-gate-wrap input:focus{outline:none;border-color:#cfa76a;}',
    '.snf-consent-row{display:flex;gap:9px;align-items:flex-start;max-width:340px;margin:0 auto 14px;text-align:left;}',
    '.snf-consent-row input{margin-top:3px;accent-color:#cfa76a;flex:0 0 auto;}',
    '.snf-consent-row label{font-size:11px;color:#8a8177;line-height:1.5;}',
    '.snf-gate-err{display:none;color:#e39a9a;font-size:12px;margin-bottom:10px;}',
    '.snf-gate-err.show{display:block;}',
    '.snf-gate-btn{background:#cfa76a;color:#16140f;border:none;padding:13px 28px;font-family:\'Barlow Condensed\',sans-serif;text-transform:uppercase;letter-spacing:.08em;font-size:13px;font-weight:600;cursor:pointer;width:100%;max-width:340px;}',
    '.snf-gate-btn:hover{background:#e3bd82;}',
    '.snf-gate-btn:disabled{opacity:.6;cursor:default;}'
  ].join('');

  var styleEl = document.createElement('style');
  styleEl.textContent = GATE_CSS;
  document.head.appendChild(styleEl);

  function initQuizGate() {
    var revealEl = document.getElementById('snfReveal');
    if (!revealEl) return;
    var obs = new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.target.classList.contains('show') && !m.target.dataset.gated) {
          m.target.dataset.gated = '1';
          injectQuizGate(m.target);
        }
      });
    });
    obs.observe(revealEl, { attributes: true, attributeFilter: ['class'] });
    var origRestart = window.snfRestart;
    window.snfRestart = function() {
      if (revealEl) delete revealEl.dataset.gated;
      var gw = document.getElementById('snfGateWrap');
      if (gw) gw.remove();
      if (origRestart) origRestart();
    };
  }

  function injectQuizGate(revealEl) {
    var buyEl = document.getElementById('snfBuy');
    var matchEl = revealEl.querySelector('.snf-match');
    var retakeEl = revealEl.querySelector('.snf-retake');
    if (buyEl) buyEl.style.display = 'none';
    if (matchEl) matchEl.style.display = 'none';
    var wrap = document.createElement('div');
    wrap.id = 'snfGateWrap';
    wrap.className = 'snf-gate-wrap';
    wrap.innerHTML =
      '<div class="snf-ge">Your Complete Reading Awaits</div>' +
      '<div class="snf-gt">Unlock The Full Profile</div>' +
      '<div class="snf-gs">Your numerological portrait, celestial blueprint, shadow archetype, and a personal reading from Mr. Sniff — sent immediately to your inbox.</div>' +
      '<div class="snf-gate-err" id="snfGateErr">Please enter a valid email, mobile number, and tick the box.</div>' +
      '<input type="email" id="snfGateEmail" placeholder="Your email" autocomplete="email">' +
      '<input type="tel" id="snfGatePhone" placeholder="Mobile number" autocomplete="tel">' +
      '<div class="snf-consent-row"><input type="checkbox" id="snfGateConsent"><label for="snfGateConsent">Yes — send me my reading and occasional Sniff London drops. I can unsubscribe anytime.</label></div>' +
      '<button class="snf-gate-btn" id="snfGateBtn" type="button">Send My Reading</button>';
    if (retakeEl && retakeEl.parentNode) {
      retakeEl.parentNode.insertBefore(wrap, retakeEl);
    } else {
      var inner = revealEl.querySelector('.snf-reveal-inner');
      if (inner) inner.appendChild(wrap);
    }
    document.getElementById('snfGateBtn').onclick = function() { submitQuizGate(buyEl, matchEl, wrap); };
  }

  function submitQuizGate(buyEl, matchEl, wrap) {
    var email = ((document.getElementById('snfGateEmail') || {}).value || '').trim();
    var phone = ((document.getElementById('snfGatePhone') || {}).value || '').trim();
    var consent = (document.getElementById('snfGateConsent') || {}).checked;
    var err = document.getElementById('snfGateErr');
    if (!email || email.indexOf('@') < 1 || !phone || !consent) { err.classList.add('show'); return; }
    err.classList.remove('show');
    var btn = document.getElementById('snfGateBtn');
    btn.disabled = true; btn.textContent = 'Sending…';
    var archName  = ((document.getElementById('snfName2') || {}).textContent || '').trim();
    var userName  = ((document.getElementById('snfName') || {}).value || '').trim();
    var signName  = ((document.getElementById('snfSignName') || {}).textContent || '').trim();
    var signSym   = ((document.getElementById('snfSignSym') || {}).textContent || '').trim();
    var signElTxt = ((document.getElementById('snfSignEl') || {}).textContent || '').split('\u00b7')[0].trim();
    var tag       = ((document.getElementById('snfTag') || {}).textContent || '').trim();
    var quote     = ((document.getElementById('snfQuote') || {}).textContent || '').trim();
    var desc      = ((document.getElementById('snfDesc') || {}).textContent || '').trim();
    var shadow    = ((document.getElementById('snfShadowName') || {}).textContent || '').trim();
    var shadowDesc= ((document.getElementById('snfShadowBody') || {}).textContent || '').trim();
    var buyHref   = ((document.getElementById('snfBuy') || {}).href || '');
    var handle    = buyHref.split('/products/')[1] || '';
    var price     = ((document.querySelector('#snfReveal .pprice') || {}).textContent || '').trim();
    var lifePath = '', expression = '', soulUrge = '';
    document.querySelectorAll('.snf-numcell').forEach(function(c) {
      var lbl = ((c.querySelector('.lbl') || {}).textContent || '').trim().toLowerCase();
      var num = ((c.querySelector('.num') || {}).textContent || '').trim();
      if (lbl === 'life path') lifePath = num;
      else if (lbl === 'expression') expression = num;
      else if (lbl === 'soul urge') soulUrge = num;
    });
    var payload = { type:'profile', email:email, phone:phone, name:userName, archetype:archName, tag:tag, quote:quote, desc:desc, mr:MR[archName]||'', lifePath:lifePath, expression:expression, soulUrge:soulUrge, sign:signName, signSym:signSym, element:signElTxt, shadow:shadow, shadowDesc:shadowDesc, handle:handle, price:price };
    function finish() { wrap.remove(); if (buyEl) buyEl.style.display=''; if (matchEl) matchEl.style.display=''; }
    fetch(SNF_WORKER_URL, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) }).then(finish).catch(finish);
    var fd = new FormData();
    fd.append('form_type','customer'); fd.append('utf8','✓'); fd.append('contact[email]',email); fd.append('contact[phone]',phone);
    if (userName) fd.append('contact[first_name]',userName.split(' ')[0]);
    fd.append('contact[tags]',['Seduction Profile',archName?'archetype:'+archName:'',signName?'sign:'+signName:'',lifePath?'lifepath:'+lifePath:''].filter(Boolean).join(', '));
    fetch('/contact',{method:'POST',body:fd}).catch(function(){});
  }

  function initMatchGate() {
    var resultEl = document.getElementById('mtcResult');
    if (!resultEl) return;
    var obs = new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.target.classList.contains('show') && !m.target.dataset.gated) {
          m.target.dataset.gated = '1';
          injectMatchGate(m.target);
        }
      });
    });
    obs.observe(resultEl, { attributes: true, attributeFilter: ['class'] });
    var retryBtn = document.getElementById('mtcRetryBtn');
    if (retryBtn) {
      var origRetry = retryBtn.onclick;
      retryBtn.onclick = function() {
        if (resultEl) delete resultEl.dataset.gated;
        var gw = document.getElementById('mtcGateWrap'); if (gw) gw.remove();
        if (origRetry) origRetry.call(this);
      };
    }
  }

  function injectMatchGate(resultEl) {
    var retryBtn = document.getElementById('mtcRetryBtn');
    var wrap = document.createElement('div');
    wrap.id = 'mtcGateWrap'; wrap.className = 'snf-gate-wrap';
    wrap.innerHTML =
      '<div class="snf-ge">The Full Match Reading</div>' +
      '<div class="snf-gt">Unlock The Full Match</div>' +
      '<div class="snf-gs">Elemental chemistry, ruling planets, archetype dynamic, and a personal read from Mr. Sniff — sent immediately to your inbox.</div>' +
      '<div class="snf-gate-err" id="mtcGateErr">Please enter a valid email, mobile number, and tick the box.</div>' +
      '<input type="email" id="mtcGateEmail" placeholder="Your email" autocomplete="email">' +
      '<input type="tel" id="mtcGatePhone" placeholder="Mobile number" autocomplete="tel">' +
      '<div class="snf-consent-row"><input type="checkbox" id="mtcGateConsent"><label for="mtcGateConsent">Yes — send me my reading and occasional Sniff London drops. I can unsubscribe anytime.</label></div>' +
      '<button class="snf-gate-btn" id="mtcGateBtn" type="button">Send My Reading</button>';
    if (retryBtn && retryBtn.parentNode) { retryBtn.parentNode.insertBefore(wrap, retryBtn); } else { resultEl.appendChild(wrap); }
    document.getElementById('mtcGateBtn').onclick = function() { submitMatchGate(wrap); };
  }

  function submitMatchGate(wrap) {
    var email = ((document.getElementById('mtcGateEmail') || {}).value || '').trim();
    var phone = ((document.getElementById('mtcGatePhone') || {}).value || '').trim();
    var consent = (document.getElementById('mtcGateConsent') || {}).checked;
    var err = document.getElementById('mtcGateErr');
    if (!email || email.indexOf('@') < 1 || !phone || !consent) { err.classList.add('show'); return; }
    err.classList.remove('show');
    var btn = document.getElementById('mtcGateBtn');
    btn.disabled = true; btn.textContent = 'Sending…';
    var score   = ((document.getElementById('mtcScore') || {}).textContent || '').replace('%','').trim();
    var verdict = ((document.getElementById('mtcVerdict') || {}).textContent || '').trim();
    var body    = ((document.getElementById('mtcBody') || {}).textContent || '').trim();
    var sign1   = ((document.getElementById('mtcSign1') || {}).textContent || '').trim();
    var sign2   = ((document.getElementById('mtcSign2') || {}).textContent || '').trim();
    var deepRead = 'A ' + score + '% score is never the whole story — it is a starting temperature, not a verdict. ' + verdict + ' means exactly what it sounds like: not easy, not guaranteed, but real if both of you actually show up for what this pairing demands. The number tells you the weather. What you do in it is still entirely your decision.';
    var payload = { type:'match', email:email, phone:phone, score:score, verdict:verdict, body:body, sign1:sign1, sign2:sign2, deepRead:deepRead };
    function finish() { wrap.remove(); }
    fetch(SNF_WORKER_URL, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload) }).then(finish).catch(finish);
    var fd = new FormData();
    fd.append('form_type','customer'); fd.append('utf8','✓'); fd.append('contact[email]',email); fd.append('contact[phone]',phone);
    fd.append('contact[tags]',['Compatibility',sign1?'sign:'+sign1:'',sign2?'sign:'+sign2:''].filter(Boolean).join(', '));
    fetch('/contact',{method:'POST',body:fd}).catch(function(){});
  }

  document.addEventListener('DOMContentLoaded', function() {
    initQuizGate();
    initMatchGate();
  });

})();
